import React, { useState } from "react";
import "./App.css";
import { Toaster } from "./components/ui/toaster";
import { LoadScript } from '@react-google-maps/api';
import { ThemeLanguageProvider, useThemeLanguage } from "./context/ThemeLanguageContext";

// Import des composants
import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Vehicles from "./components/Vehicles";
import Pricing from "./components/Pricing";
import GoogleReviews from "./components/GoogleReviews";
import Contact from "./components/Contact";
import BookingForm from "./components/BookingForm";
import ReservationsList from "./components/ReservationsList";

const libraries = ['places'];

function AppContent() {
  const { t } = useThemeLanguage();
  const [isBookingFormOpen, setIsBookingFormOpen] = useState(false);
  const [showAdminPanel, setShowAdminPanel] = useState(false);

  // Fonction pour ouvrir le formulaire
  const handleBookingClick = () => setIsBookingFormOpen(true);

  // Fonction pour fermer le formulaire
  const handleBookingClose = () => setIsBookingFormOpen(false);

  // Toggle panneau admin
  const toggleAdminPanel = () => setShowAdminPanel(!showAdminPanel);

  if (showAdminPanel) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
        <div className="bg-white dark:bg-gray-800 shadow-sm border-b dark:border-gray-700">
          <div className="max-w-7xl mx-auto px-6 py-4">
            <div className="flex items-center justify-between">
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">{t('nav.administration')}</h1>
              <button
                onClick={toggleAdminPanel}
                className="px-4 py-2 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600"
                type="button"
              >
                {t('nav.backToSite')}
              </button>
            </div>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-6 py-8">
          <ReservationsList />
        </div>
      </div>
    );
  }

  return (
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
      libraries={libraries}
    >
      <div className="App">
        {/* Navigation */}
        <Navigation onBookingClick={handleBookingClick} />

        {/* Hero Section */}
        <section id="home">
          <Hero onBookingClick={handleBookingClick} />
        </section>

        {/* Services Section */}
        <Services />

        {/* Vehicles Section */}
        <section id="vehicles">
          <Vehicles onBookingClick={handleBookingClick} />
        </section>

        {/* Pricing Section */}
        <section id="pricing">
          <Pricing onBookingClick={handleBookingClick} />
        </section>

        {/* Google Reviews Section */}
        <GoogleReviews />

        {/* Contact Section */}
        <section id="contact">
          <Contact />
        </section>

        {/* Booking Form Modal */}
        <BookingForm 
          isOpen={isBookingFormOpen} 
          onClose={handleBookingClose} 
        />

        {/* Footer */}
        <footer className="bg-black text-white py-12">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid md:grid-cols-3 gap-8 mb-8">
              <div>
                <h3 className="text-2xl font-light mb-4">Riviera Signature VTC</h3>
                <p className="text-gray-400 leading-relaxed">
                  {t('footer.description')}
                </p>
              </div>
              <div>
                <h4 className="font-medium mb-4">{t('footer.services')}</h4>
                <div className="space-y-2 text-gray-400">
                  <div>{t('footer.privateTransfer')}</div>
                  <div>{t('footer.airportTransfer')}</div>
                  <div>{t('footer.trainTransfer')}</div>
                  <div>{t('footer.disposal')}</div>
                  <div>{t('footer.eventTransfer')}</div>
                </div>
              </div>
              <div>
                <h4 className="font-medium mb-4">{t('footer.contact')}</h4>
                <div className="space-y-2 text-gray-400">
                  <div>+33 7 49 77 73 71</div>
                  <div>contact@RivieraSignaturevtc.fr</div>
                  <div>Nice et Côte d'Azur</div>
                </div>
              </div>
            </div>
            <div className="pt-8 border-t border-gray-800 text-center">
              <p className="text-gray-400">
                <button
                  onClick={toggleAdminPanel}
                  className="hover:text-gray-300 transition-colors cursor-default"
                  title=""
                  type="button"
                >
                  ©
                </button>
                {" "}2026 Riviera Signature VTC. {t('footer.allRightsReserved')}
              </p>
            </div>
          </div>
        </footer>

        {/* Toast Notifications */}
        <Toaster />
      </div>
    </LoadScript>
  );
}

export default App;

function App() {
  return (
    <ThemeLanguageProvider>
      <AppContent />
    </ThemeLanguageProvider>
  );
}
